export const INSTRUMENTATION = {
  SERVICE_NAME: 'varicon-frontend',
} as const;
